import { dashboardBFF } from "../axios-instances";
import { CollectorStatus } from "./types";
import { getServices } from "src/logs";

const { logger } = getServices();

export const getCollectorStatus = async (
  date: string,
  logsDetailedFeature?: boolean | undefined
): Promise<CollectorStatus> => {
  const uri = `api/infrastructureDevices/active/count?api-version=1.0&date=${encodeURIComponent(date)}`;
  try {
    // if ((process.env.REACT_APP_ENVIRONMENT || "").toLowerCase() === "development") {
    //   console.log("getCollectorStatus:", uri);
    // }

    const response = await dashboardBFF.get(uri, { timeout: 3000 });

    // if ((process.env.REACT_APP_ENVIRONMENT || "").toLowerCase() === "development") {
    //   console.log("getCollectorStatus, response:", response.data);
    // }

    if (response.status === 204) {
      // no content
      const err = new Error("No content, http status code: 204");
      throw err;
    }

    const collectorStatus: CollectorStatus = response.data;

    if (logsDetailedFeature) {
      logger.logTrace({
        message: "getCollectorStatus - response",
        properties: {
          type: collectorStatus.totalConcentrators.toString(),
          count: collectorStatus.activeConcentrators.toString()
        }
      });
    }

    return collectorStatus;
  } catch (error) {
    const err = error as Error;
    if (!err.message.includes("204")) {
      logger.logError({
        message: "getCollectorStatus - Exception",
        properties: {
          name: err.name,
          message: err.message,
          stack: err.stack || "unknown stack",
          cause: String(err.cause ?? "unknown cause")
        }
      });
    }
    throw error;
  }
};

